var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maindiv env-wrap bg-gray index_main"},[_c('div',{staticClass:"list-bg news-bg"}),_vm._v(" "),_c('div',{staticClass:"bgw tborder"},[_c('div',{staticClass:"bar-menu htmldiv tcenter fs0 pb40"},[(_vm.pid >= 0)?_c('left',{attrs:{"pid":_vm.pid}}):_vm._e(),_vm._v(" "),_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17a50b5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/evn/index.vue
// module id = null
// module chunks = 